// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/TxStatuses/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_TxStatuses{
  result: onboarding_inputs_tx_statuses {
    ok
  }
}

`